import { useTranslation } from 'react-i18next'

import { WarningIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import SizingIssuesReasonTag from '@/metrics/components/SizingIssuesReasonTag/SizingIssuesReasonTag'
import { getReasonTextColor, toPercent } from '@/metrics/helpers/helpers'

import * as Styles from './styles'

const ReasonRow = ({ reason, data }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const percentageColor = getReasonTextColor(reason, theme)

  return (
    <Styles.Container>
      <Styles.Bullet />

      <Styles.PercentageAndTag>
        <Text type="bodyMBold" color={percentageColor}>
          {toPercent(data.product_return_rate)}%
        </Text>

        <SizingIssuesReasonTag reason={reason} />
      </Styles.PercentageAndTag>

      <Text type="bodySRegular" color={theme.colors.text.muted}>
        {t('Media de categoría:')}{' '}
        <Text type="bodySBold" tag="span" color={theme.colors.text.muted}>
          {toPercent(data.category_return_rate_avg)}%
        </Text>
      </Text>

      {data.recommendation && (
        <WarningIcon data-testid="reason-row-alert" size={20} weight="fill" color={theme.colors.accent.hover} />
      )}
    </Styles.Container>
  )
}

export default ReasonRow
